import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthBackendService } from '../../../auth/service/auth-backend.service';
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TokenValidityResolver {
  constructor(private auth: AuthBackendService) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<boolean> {
    const { token } = route.params as { token: string };
    return firstValueFrom(this.auth.checkPasswordResetToken(token));
  }
}
